var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarrantyLogo10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0293 13.8235H23.0881V26.1764H21.0293V13.8235Z",
    fill: "#0473EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2656 13.8235H31.3244V26.1764H29.2656V13.8235Z",
    fill: "#0473EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9121 13.8235H18.9709V26.1764H16.9121V13.8235Z",
    fill: "#0473EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1465 13.8235H27.2053V26.1764H25.1465V13.8235Z",
    fill: "#0473EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7949 13.8235H14.8537V26.1764H12.7949V13.8235Z",
    fill: "#0473EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67578 13.8235H10.7346V26.1764H8.67578V13.8235Z",
    fill: "#0473EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4118 6.61765H31.3235V4.55882H33.3824V2.5H25.1471V4.55882H27.2059V6.61765H18.9706V4.55882L16.9118 2.5H9.70588L7.64706 4.55882V6.61765H5.58824C3.88264 6.61765 2.5 8.00028 2.5 9.70588V30.2941C2.5 31.9997 3.88264 33.3824 5.58824 33.3824H7.64706V35.4412H5.58824V37.5H13.8235V35.4412H11.7647V33.3824H34.4118C36.1174 33.3824 37.5 31.9997 37.5 30.2941V9.70588C37.5 8.00028 36.1174 6.61765 34.4118 6.61765ZM33.3824 28.2353H6.61765V11.7647H33.3824V28.2353Z",
    fill: "#0473EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyLogo10);
export default __webpack_public_path__ + "static/media/warranty-logo10.b249cabf33e982225bcee2543771da38.svg";
export { ForwardRef as ReactComponent };